/*
 * Copyright (c) 2021 OTB Africa. All rights reserved. <https://otbafrica.com>
 *
 * Created Date: Wednesday, September 22nd 2021, 11:44:01 am
 * Author: OTB Africa, developers@otbafrica.com
 *
 * Use of this source code is governed by the license that can be found in
 * the LICENSE file or at https://developers.otbafrica.com/licenses/
 */

import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";
import React, { HTMLProps } from "react";
import { OSPaperContainer } from "ui-widgets/layouts/Paper";

interface CardWidgetProps extends HTMLProps<HTMLDivElement> {
  title?: string;
  action_text?: string;
}

export const CardWidget = ({ title, children, action_text }: CardWidgetProps) => {
  return (
    <Card sx={{ minWidth: 275 }}>
      <OSPaperContainer>
        <CardContent>
          {title ? (
            <React.Fragment>
              <Typography align="left" sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>
                {title}
              </Typography>
              <Divider />
            </React.Fragment>
          ) : null}

          {children}
        </CardContent>
        {action_text ? (
          <CardActions>
            <Button size="small">{action_text}</Button>
          </CardActions>
        ) : null}
      </OSPaperContainer>
    </Card>
  );
};
